import React from "react";
import useAuth from "~/src/auth/hooks/use-auth";

export const withAuth = Component => props => {
  const auth = useAuth();
  return <Component auth={auth} {...props} />;
};
